package org.hs_soft.runmynesto.domain.usecase.options.menu_card_import

import org.hs_soft.runmynesto.domain.model.home.options.menu_card_import.menu_card_model.MenuCardModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.menu_card_import.UpsertProductsRepository
import org.hs_soft.runmynesto.domain.model.home.options.menu_card_import.upsert_products.UpsertProductsModel

class UpsertProductsUseCase(private val repository: UpsertProductsRepository) {
    suspend operator fun invoke(
        menuCard: MenuCardModel,
        categoryIds:List<String>,
        ingredientIds: List<List<String>>,
        turnoverGroupIds: List<String?>,
        productLocationIds: List<List<Boolean>>
    ): UpsertProductsModel {
        return repository.upsertProducts(
            menuCard = menuCard,
            categoryIds = categoryIds,
            ingredientIds = ingredientIds,
            turnoverGroupIds = turnoverGroupIds,
            productLocationIds = productLocationIds
        )
    }
    
    fun cancel() {
        repository.cancel()
    }
}